import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withMemo as _withMemo, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/放大镜.png';
const _hoisted_1 = {
  id: "div1",
  style: {
    "height": "100%",
    "width": "100%",
    "position": "relative"
  }
};
const _hoisted_2 = ["aria-busy"];
const _hoisted_3 = {
  class: "el-loading-spinner"
};
const _hoisted_4 = {
  class: "el-loading-text"
};
const _hoisted_5 = {
  key: 0,
  class: "desen-student-search-mode"
};
const _hoisted_6 = {
  key: 4,
  style: {
    "height": "50px",
    "position": "absolute",
    "top": "0",
    "right": "480px",
    "margin": "187px 0 0 0px",
    "font-size": "18px",
    "font-weight": "bold",
    "color": "#0d2f89",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_7 = {
  key: 5,
  id: "datePicker",
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "margin": "184px 0 0 1494px",
    "border-radius": "15px",
    "border": "1px solid #002483",
    "overflow": "hidden",
    "width": "336px",
    "height": "56px"
  }
};
const _hoisted_8 = {
  key: 6,
  class: "desen-statistics-toolbar"
};
const _hoisted_9 = {
  id: "datePicker",
  class: "desen-date-range"
};
const _hoisted_10 = {
  class: "desen-export-field"
};
const _hoisted_11 = {
  class: "desen-export-field"
};
const _hoisted_12 = {
  style: {
    "min-height": "50px",
    "flex": "3",
    "display": "flex"
  }
};
const _hoisted_13 = {
  style: {
    "flex": "1",
    "font-size": "20px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_14 = {
  style: {
    "flex": "1",
    "font-size": "20px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_15 = {
  style: {
    "flex": "1",
    "font-size": "20px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_16 = {
  style: {
    "min-height": "50px",
    "flex": "3"
  }
};
const _hoisted_17 = {
  style: {
    "flex": "1",
    "text-align": "center"
  }
};
const _hoisted_18 = {
  style: {
    "flex": "1",
    "text-align": "center"
  }
};
const _hoisted_19 = {
  style: {
    "flex": "1",
    "text-align": "center"
  }
};
const _hoisted_20 = {
  style: {
    "flex": "1",
    "font-size": "20px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_21 = {
  key: 0,
  class: "desen-statistics-footer desen-aggregate-footer"
};
const _hoisted_22 = {
  class: "desen-data-row-count"
};
const _hoisted_23 = {
  class: "desen-total-hour"
};
const _hoisted_24 = {
  key: 1,
  style: {
    "height": "56px",
    "width": "149px",
    "margin": "20px 0 0 1340px",
    "font-size": "22px",
    "font-weight": "bold"
  }
};
const _hoisted_25 = {
  style: {
    "flex": "1",
    "display": "flex"
  }
};
const _hoisted_26 = {
  style: {
    "flex": "1",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "font-size": "20px",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_27 = {
  style: {
    "flex": "5"
  }
};
const _hoisted_28 = {
  style: {
    "min-height": "50px",
    "flex": "3",
    "display": "flex"
  }
};
const _hoisted_29 = {
  style: {
    "flex": "1",
    "font-size": "20px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_30 = {
  style: {
    "flex": "1",
    "font-size": "20px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_31 = {
  style: {
    "flex": "1",
    "font-size": "20px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_32 = {
  style: {
    "flex": "2"
  }
};
const _hoisted_33 = {
  style: {
    "flex": "1",
    "text-align": "center"
  }
};
const _hoisted_34 = {
  style: {
    "flex": "1",
    "text-align": "center"
  }
};
const _hoisted_35 = {
  style: {
    "flex": "1",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "font-size": "20px",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_36 = {
  key: 0,
  class: "desen-statistics-footer desen-aggregate-footer"
};
const _hoisted_37 = {
  class: "desen-data-row-count"
};
const _hoisted_38 = {
  class: "desen-total-hour"
};
const _hoisted_39 = {
  key: 1,
  style: {
    "height": "56px",
    "width": "149px",
    "margin": "20px 0 0 1370px",
    "font-size": "22px",
    "font-weight": "bold"
  }
};
const _hoisted_40 = ["aria-hidden"];
const _hoisted_41 = {
  class: "desen-statistics-footer desen-student-footer"
};
const _hoisted_42 = {
  class: "desen-checkbox-row-count"
};
const _hoisted_43 = {
  class: "desen-total-hour"
};
const _hoisted_44 = {
  class: "desen-student-hour-summary"
};
const _hoisted_45 = {
  key: 0,
  class: "desen-other-hour"
};
const _hoisted_46 = {
  class: "desen-student-total-hour"
};
const _hoisted_47 = {
  key: 10,
  style: {
    "height": "695px",
    "width": "1514px",
    "position": "absolute",
    "top": "0",
    "left": "0",
    "margin": "322px 0 0 360px",
    "background": "white"
  }
};
const _hoisted_48 = {
  style: {
    "max-height": "517px",
    "width": "1514px",
    "overflow-y": "auto",
    "overflow-x": "hidden",
    "margin": "0px 0 0 0px",
    "background": "white",
    "border-bottom": "1px solid #d5d8e1",
    "white-space": "normal"
  }
};
const _hoisted_49 = {
  style: {
    "flex": "1",
    "display": "flex"
  }
};
const _hoisted_50 = {
  style: {
    "flex": "1",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "font-size": "20px",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_51 = {
  style: {
    "flex": "5"
  }
};
const _hoisted_52 = {
  style: {
    "min-height": "50px",
    "flex": "3",
    "display": "flex"
  }
};
const _hoisted_53 = {
  style: {
    "flex": "1",
    "font-size": "20px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_54 = {
  style: {
    "flex": "1",
    "font-size": "20px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_55 = {
  style: {
    "flex": "1",
    "font-size": "20px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_56 = {
  style: {
    "flex": "2"
  }
};
const _hoisted_57 = {
  style: {
    "flex": "1",
    "text-align": "center"
  }
};
const _hoisted_58 = {
  style: {
    "flex": "1",
    "text-align": "center"
  }
};
const _hoisted_59 = {
  style: {
    "flex": "1",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "font-size": "20px",
    "border-bottom": "1px solid #d5d8e1"
  }
};
const _hoisted_60 = {
  style: {
    "height": "56px",
    "width": "149px",
    "margin": "20px 0 0 1370px",
    "font-size": "22px",
    "font-weight": "bold"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.institution === '得森' ? (_openBlock(), _createBlock(_Teleport, {
    key: 0,
    to: "body"
  }, [_withDirectives(_createElementVNode("div", {
    class: "desen-statistics-loading el-loading-mask is-fullscreen",
    role: "status",
    "aria-live": "polite",
    "aria-busy": $data.statisticsBusy
  }, [_createElementVNode("div", _hoisted_3, [_cache[24] || (_cache[24] = _createElementVNode("svg", {
    class: "circular",
    viewBox: "0 0 50 50"
  }, [_createElementVNode("circle", {
    class: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none"
  })], -1)), _createElementVNode("p", _hoisted_4, _toDisplayString($data.statisticsLoadingText), 1)])], 8, _hoisted_2), [[_vShow, $data.statisticsBusy]])])) : _createCommentVNode("", true), _cache[41] || (_cache[41] = _createElementVNode("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "248px 0 0 380px",
      "height": "65px",
      "width": "540px",
      "background": "white"
    }
  }, null, -1)), $data.showStatisticsType == 'class' ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass({
      'desen-statistics-tabs': $data.institution === '得森'
    }),
    style: {
      "font-size": "19px",
      "font-weight": "bold",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "255px 0 0 407px",
      "border-radius": "15px",
      "background": "#edf1fb",
      "height": "45px",
      "width": "240px"
    }
  }, [_cache[25] || (_cache[25] = _createElementVNode("div", {
    style: {
      "font-size": "19px",
      "font-weight": "bold",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "margin": "0px 0 0 0px",
      "border-radius": "15px",
      "color": "white",
      "background": "#0d2f89",
      "height": "100%",
      "width": "120px"
    }
  }, " 班级 ", -1)), _createElementVNode("div", {
    style: {
      "font-size": "19px",
      "font-weight": "bold",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "margin": "0px 0 0 0px",
      "border-radius": "15px",
      "color": "grey",
      "height": "100%",
      "width": "120px"
    },
    onClick: _cache[0] || (_cache[0] = $event => $options.classTeacherSwitch('teacher')),
    onmouseover: "this.style.cursor='pointer'"
  }, " 老师 "), _createElementVNode("div", {
    style: {
      "font-size": "19px",
      "font-weight": "bold",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "margin": "0px 0 0 0px",
      "border-radius": "15px",
      "color": "grey",
      "height": "100%",
      "width": "120px"
    },
    onClick: _cache[1] || (_cache[1] = $event => $options.classTeacherSwitch('student')),
    onmouseover: "this.style.cursor='pointer'"
  }, " 学生 ")], 2)) : _createCommentVNode("", true), $data.showStatisticsType == 'teacher' ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass({
      'desen-statistics-tabs': $data.institution === '得森'
    }),
    style: {
      "font-size": "19px",
      "font-weight": "bold",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "255px 0 0 407px",
      "border-radius": "15px",
      "background": "#edf1fb",
      "height": "45px",
      "width": "240px"
    }
  }, [_createElementVNode("div", {
    style: {
      "font-size": "19px",
      "font-weight": "bold",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "margin": "0px 0 0 0px",
      "border-radius": "15px",
      "color": "grey",
      "height": "100%",
      "width": "120px"
    },
    onClick: _cache[2] || (_cache[2] = $event => $options.classTeacherSwitch('class')),
    onmouseover: "this.style.cursor='pointer'"
  }, " 班级 "), _cache[26] || (_cache[26] = _createElementVNode("div", {
    style: {
      "font-size": "19px",
      "font-weight": "bold",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "margin": "0px 0 0 0px",
      "border-radius": "15px",
      "color": "white",
      "background": "#0d2f89",
      "height": "100%",
      "width": "120px"
    }
  }, " 老师 ", -1)), _createElementVNode("div", {
    style: {
      "font-size": "19px",
      "font-weight": "bold",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "margin": "0px 0 0 0px",
      "border-radius": "15px",
      "color": "grey",
      "height": "100%",
      "width": "120px"
    },
    onClick: _cache[3] || (_cache[3] = $event => $options.classTeacherSwitch('student')),
    onmouseover: "this.style.cursor='pointer'"
  }, " 学生 ")], 2)) : _createCommentVNode("", true), $data.showStatisticsType == 'student' ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: _normalizeClass({
      'desen-statistics-tabs': $data.institution === '得森'
    }),
    style: {
      "font-size": "19px",
      "font-weight": "bold",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "255px 0 0 407px",
      "border-radius": "15px",
      "background": "#edf1fb",
      "height": "45px",
      "width": "240px"
    }
  }, [_createElementVNode("div", {
    style: {
      "font-size": "19px",
      "font-weight": "bold",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "margin": "0px 0 0 0px",
      "border-radius": "15px",
      "color": "grey",
      "height": "100%",
      "width": "120px"
    },
    onClick: _cache[4] || (_cache[4] = $event => $options.classTeacherSwitch('class')),
    onmouseover: "this.style.cursor='pointer'"
  }, " 班级 "), _createElementVNode("div", {
    style: {
      "font-size": "19px",
      "font-weight": "bold",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "margin": "0px 0 0 0px",
      "border-radius": "15px",
      "color": "grey",
      "height": "100%",
      "width": "120px"
    },
    onClick: _cache[5] || (_cache[5] = $event => $options.classTeacherSwitch('teacher')),
    onmouseover: "this.style.cursor='pointer'"
  }, " 老师 "), _createElementVNode("div", {
    style: {
      "font-size": "19px",
      "font-weight": "bold",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "margin": "0px 0 0 0px",
      "border-radius": "15px",
      "color": "white",
      "background": "#0d2f89",
      "height": "100%",
      "width": "120px"
    },
    onClick: _cache[6] || (_cache[6] = $event => $options.classTeacherSwitch('student')),
    onmouseover: "this.style.cursor='pointer'"
  }, " 学生 ")], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass({
      'desen-student-search': $data.institution === '得森' && $data.showStatisticsType === 'student'
    }),
    style: {
      "height": "48px",
      "min-width": "370px",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "186px 0 0 403px",
      "background": "white"
    }
  }, [_createVNode(_component_el_input, {
    class: "searchInput",
    placeholder: `${$data.searchPlaceholder}`,
    style: {
      "height": "48px",
      "width": "355px",
      "font-size": "15px",
      "color": "#717579",
      "margin": "0px 0 0 0px"
    },
    modelValue: $data.searchStr,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.searchStr = $event),
    onInput: _cache[8] || (_cache[8] = $event => $options.search())
  }, null, 8, ["placeholder", "modelValue"]), _cache[29] || (_cache[29] = _createElementVNode("img", {
    src: _imports_0,
    style: {
      "height": "27px",
      "width": "27px",
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "margin": "10.5px 0 0 300px"
    }
  }, null, -1)), $data.institution === '得森' && $data.showStatisticsType === 'student' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_cache[27] || (_cache[27] = _createElementVNode("span", null, "按", -1)), _createVNode(_component_el_select, {
    modelValue: $data.desenStudentSearchField,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.desenStudentSearchField = $event),
    "aria-label": "搜索对象",
    disabled: $data.statisticsBusy
  }, {
    default: _withCtx(() => [_createVNode(_component_el_option, {
      label: "学生",
      value: "studentName"
    }), _createVNode(_component_el_option, {
      label: "老师",
      value: "teacherName"
    }), _createVNode(_component_el_option, {
      label: "班级",
      value: "className"
    })]),
    _: 1
  }, 8, ["modelValue", "disabled"]), _cache[28] || (_cache[28] = _createElementVNode("span", null, "搜索", -1))])) : _createCommentVNode("", true)], 2), $data.institution != '得森' || $data.showStatisticsType != 'student' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
    style: {
      "height": "50px",
      "min-width": "162px",
      "padding": "0 20px 0 20px",
      "line-height": "1",
      "border": "1px solid #0d2f89",
      "border-radius": "15px",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    },
    onClick: _cache[10] || (_cache[10] = $event => $options.downloadStatistics_withDetail()),
    onmouseover: "this.style.cursor='pointer'"
  }, _cache[30] || (_cache[30] = [_createTextVNode(" 导出课时统计", -1), _createElementVNode("br", null, null, -1), _createTextVNode("(含每节课详情) ", -1)])), _createElementVNode("div", {
    style: {
      "height": "50px",
      "min-width": "162px",
      "padding": "0 20px 0 20px",
      "line-height": "1",
      "border": "1px solid #0d2f89",
      "border-radius": "15px",
      "margin-left": "30px",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    },
    onClick: _cache[11] || (_cache[11] = $event => $options.downloadStatistics_withoutDetail()),
    onmouseover: "this.style.cursor='pointer'"
  }, _cache[31] || (_cache[31] = [_createTextVNode(" 导出课时统计", -1), _createElementVNode("br", null, null, -1), _createTextVNode("(不含每节课详情) ", -1)]))])) : _createCommentVNode("", true), $data.institution !== '得森' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_date_picker, {
    modelValue: $data.dateRange,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.dateRange = $event),
    type: "daterange",
    "range-separator": "至",
    "start-placeholder": "开始日期",
    "end-placeholder": "结束日期",
    format: "YYYY-MM-DD",
    "value-format": "YYYY-MM-DD",
    style: {
      "width": "100%",
      "height": "100%",
      "background": "#edf1fb"
    },
    onChange: _cache[13] || (_cache[13] = $event => $options.dateRangeChange()),
    clearable: false
  }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), $data.institution === '得森' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [$data.showStatisticsType === 'student' ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "desen-export-button",
    onClick: _cache[14] || (_cache[14] = (...args) => $options.openDesenExport && $options.openDesenExport(...args))
  }, " 导出课时 ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_date_picker, {
    modelValue: $data.dateRange,
    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.dateRange = $event),
    type: "daterange",
    "range-separator": "至",
    "start-placeholder": "开始日期",
    "end-placeholder": "结束日期",
    format: "YYYY-MM-DD",
    "value-format": "YYYY-MM-DD",
    clearable: false,
    disabled: $data.statisticsBusy,
    style: {
      "width": "100%",
      "height": "100%",
      "background": "#edf1fb"
    },
    onChange: _cache[16] || (_cache[16] = $event => $options.dateRangeChange())
  }, null, 8, ["modelValue", "disabled"])])])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
    modelValue: $data.showDesenExportDialog,
    "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.showDesenExportDialog = $event),
    title: "选择导出范围",
    width: "460px"
  }, {
    footer: _withCtx(() => [_createVNode(_component_el_button, {
      onClick: _cache[19] || (_cache[19] = $event => $data.showDesenExportDialog = false)
    }, {
      default: _withCtx(() => _cache[34] || (_cache[34] = [_createTextVNode("取消", -1)])),
      _: 1,
      __: [34]
    }), _createVNode(_component_el_button, {
      type: "primary",
      loading: $data.exportingDesen,
      onClick: $options.exportDesenStatistics
    }, {
      default: _withCtx(() => _cache[35] || (_cache[35] = [_createTextVNode(" 导出 ", -1)])),
      _: 1,
      __: [35]
    }, 8, ["loading", "onClick"])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_cache[32] || (_cache[32] = _createElementVNode("div", {
      class: "desen-export-field-label"
    }, "日期范围", -1)), _createVNode(_component_el_date_picker, {
      modelValue: $data.exportDateRange,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.exportDateRange = $event),
      type: "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      format: "YYYY-MM-DD",
      "value-format": "YYYY-MM-DD",
      clearable: false,
      style: {
        "width": "100%"
      }
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_11, [_cache[33] || (_cache[33] = _createElementVNode("div", {
      class: "desen-export-field-label"
    }, " 学生 ", -1)), _createVNode(_component_el_select, {
      modelValue: $data.exportTargetId,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.exportTargetId = $event),
      filterable: "",
      clearable: "",
      placeholder: "搜索并选择学生（默认全部）",
      style: {
        "width": "100%"
      }
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.desenExportTargetOptions, option => {
        return _openBlock(), _createBlock(_component_el_option, {
          key: option.id,
          label: option.name,
          value: option.id
        }, null, 8, ["label", "value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  }, 8, ["modelValue"]), _cache[42] || (_cache[42] = _createElementVNode("div", {
    style: {
      "height": "56px",
      "width": "149px",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "245px 0 0 1687px",
      "background": "white"
    }
  }, null, -1)), ($data.institution === '得森' ? $data.desenMountedViews.class : $data.showStatisticsType === 'class') ? _withMemo([$data.institution === '得森' ? $data.classCourseTeacherHour : {}, $data.classHours, $data.classNames, $data.classType, $data.classCampusId, $data.campusNames, $data.teacherNames, $data.totalHour, $data.displayedStatisticsType], () => _withDirectives((_openBlock(), _createElementBlock("div", {
    key: 7,
    style: _normalizeStyle([{
      "height": "695px",
      "width": "1514px",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "322px 0 0 360px",
      "background": "white"
    }, $data.institution === '得森' ? {
      height: '745px'
    } : null])
  }, [_cache[36] || (_cache[36] = _createStaticVNode("<div style=\"height:78px;width:1514px;display:flex;align-items:center;font-size:20px;font-weight:bold;border-top:1px solid #d5d8e1;border-bottom:1px solid #d5d8e1;padding:0px 0 0 0px;\" data-v-f7bf24f2><div style=\"width:270px;text-align:center;\" data-v-f7bf24f2>班级名称</div><div style=\"width:270px;text-align:center;\" data-v-f7bf24f2>班级类型</div><div style=\"width:270px;text-align:center;\" data-v-f7bf24f2>校区名称</div><div style=\"width:270px;text-align:center;\" data-v-f7bf24f2>科目</div><div style=\"width:270px;text-align:center;\" data-v-f7bf24f2>老师姓名</div><div style=\"width:270px;text-align:center;\" data-v-f7bf24f2>课时(小时)</div><div style=\"width:270px;text-align:center;\" data-v-f7bf24f2>课时合计</div></div>", 1)), _createElementVNode("div", {
    class: "statistics-aggregate-scroll",
    style: _normalizeStyle([{
      "max-height": "517px",
      "width": "1514px",
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "margin": "0px 0 0 0px",
      "background": "white",
      "border-bottom": "1px solid #d5d8e1",
      "white-space": "normal"
    }, $data.institution === '得森' ? {
      maxHeight: '567px'
    } : null])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.classCourseTeacherHour, (item, classId) => {
    return _openBlock(), _createElementBlock("div", {
      key: classId,
      style: {
        "width": "1514px",
        "display": "flex"
      }
    }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString($data.classNames[classId]), 1), _createElementVNode("div", _hoisted_14, _toDisplayString($data.classType[classId]), 1), _createElementVNode("div", _hoisted_15, _toDisplayString($data.campusNames[$data.classCampusId[classId]]), 1)]), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.classCourseTeacherHour[classId], (item2, course) => {
      return _openBlock(), _createElementBlock("div", {
        key: course,
        style: {
          "width": "100%"
        }
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.classCourseTeacherHour[classId][course], (item3, teacherId) => {
        return _openBlock(), _createElementBlock("div", {
          key: teacherId,
          style: {
            "height": "78px",
            "width": "100%",
            "display": "flex",
            "align-items": "center",
            "font-size": "20px",
            "border-bottom": "1px solid #d5d8e1",
            "padding": "0px 0 0 0px"
          }
        }, [_createElementVNode("div", _hoisted_17, _toDisplayString(item3.course), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(item3.teacherName), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(item3.hour), 1)]);
      }), 128))]);
    }), 128))]), _createElementVNode("div", _hoisted_20, _toDisplayString($data.classHours[classId]), 1)]);
  }), 128))], 4), $data.institution === '得森' ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, "共 " + _toDisplayString($options.desenClassRowCount) + " 行数据", 1), _createElementVNode("div", _hoisted_23, "共" + _toDisplayString(parseFloat($data.totalHour.toFixed(2))) + "小时", 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_24, " 共" + _toDisplayString(parseFloat($data.totalHour.toFixed(2))) + "小时 ", 1))], 4)), [[_vShow, ($data.institution === '得森' ? $data.displayedStatisticsType : $data.showStatisticsType) === 'class']]), _cache, 21) : _createCommentVNode("", true), ($data.institution === '得森' ? $data.desenMountedViews.teacher : $data.showStatisticsType === 'teacher') ? _withMemo([$data.institution === '得森' ? $data.teacherClassCourseHour : {}, $data.teacherHours, $data.teacherNames, $data.classNames, $data.classType, $data.classCampusId, $data.campusNames, $data.totalHour, $data.displayedStatisticsType], () => _withDirectives((_openBlock(), _createElementBlock("div", {
    key: 8,
    style: _normalizeStyle([{
      "height": "695px",
      "width": "1514px",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "322px 0 0 360px",
      "background": "white"
    }, $data.institution === '得森' ? {
      height: '745px'
    } : null])
  }, [_cache[37] || (_cache[37] = _createStaticVNode("<div style=\"height:78px;width:1514px;display:flex;align-items:center;font-size:20px;font-weight:bold;border-top:1px solid #d5d8e1;border-bottom:1px solid #d5d8e1;padding:0px 0 0 0px;\" data-v-f7bf24f2><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>老师姓名</div><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>班级</div><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>班级类型</div><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>校区名称</div><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>科目</div><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>课时(小时)</div><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>课时合计</div></div>", 1)), _createElementVNode("div", {
    class: "statistics-aggregate-scroll",
    style: _normalizeStyle([{
      "max-height": "517px",
      "width": "1514px",
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "margin": "0px 0 0 0px",
      "background": "white",
      "border-bottom": "1px solid #d5d8e1",
      "white-space": "normal"
    }, $data.institution === '得森' ? {
      maxHeight: '567px'
    } : null])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teacherClassCourseHour, (item, teacherId) => {
    return _openBlock(), _createElementBlock("div", {
      key: teacherId,
      style: {
        "width": "1514px",
        "display": "flex"
      }
    }, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString($data.teacherNames[teacherId]), 1)]), _createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teacherClassCourseHour[teacherId], (item2, classId) => {
      return _openBlock(), _createElementBlock("div", {
        key: classId,
        style: {
          "flex": "5",
          "display": "flex"
        }
      }, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString($data.classNames[classId]), 1), _createElementVNode("div", _hoisted_30, _toDisplayString($data.classType[classId]), 1), _createElementVNode("div", _hoisted_31, _toDisplayString($data.campusNames[$data.classCampusId[classId]]), 1)]), _createElementVNode("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teacherClassCourseHour[teacherId][classId], (item3, course) => {
        return _openBlock(), _createElementBlock("div", {
          key: course,
          style: {
            "height": "78px",
            "flex": "2",
            "display": "flex",
            "align-items": "center",
            "font-size": "20px",
            "border-bottom": "1px solid #d5d8e1",
            "padding": "0px 0 0 0px"
          }
        }, [_createElementVNode("div", _hoisted_33, _toDisplayString(item3.course), 1), _createElementVNode("div", _hoisted_34, _toDisplayString(item3.hour), 1)]);
      }), 128))])]);
    }), 128))]), _createElementVNode("div", _hoisted_35, _toDisplayString($data.teacherHours[teacherId]), 1)]);
  }), 128))], 4), $data.institution === '得森' ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, "共 " + _toDisplayString($options.desenTeacherRowCount) + " 行数据", 1), _createElementVNode("div", _hoisted_38, "共" + _toDisplayString(parseFloat($data.totalHour.toFixed(2))) + "小时", 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_39, " 共" + _toDisplayString(parseFloat($data.totalHour.toFixed(2))) + "小时 ", 1))], 4)), [[_vShow, ($data.institution === '得森' ? $data.displayedStatisticsType : $data.showStatisticsType) === 'teacher']]), _cache, 22) : _createCommentVNode("", true), $data.institution === '得森' && $data.desenMountedViews.student ? (_openBlock(), _createElementBlock("div", {
    key: 9,
    style: _normalizeStyle({
      visibility: $data.displayedStatisticsType === 'student' ? 'visible' : 'hidden'
    }),
    "aria-hidden": $data.displayedStatisticsType !== 'student',
    class: "desen-statistics-table"
  }, [_withMemo([$options.desenVisibleRows], () => _createVNode(_component_el_table, {
    ref: "desenTableRef",
    data: $options.desenVisibleRows,
    height: "620",
    border: "",
    "native-scrollbar": "",
    style: _normalizeStyle($options.desenVirtualStyle),
    "row-key": $options.desenRowKey,
    "span-method": $options.desenSpanMethod,
    "empty-text": "所选日期范围内暂无排课",
    onScroll: $options.desenVirtualScroll,
    onCellMouseEnter: $options.showDesenCellTooltip,
    onCellMouseLeave: $options.hideDesenCellTooltip
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "studentName",
      label: "学生",
      "min-width": "100",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "date",
      label: "日期",
      width: "115",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "className",
      label: "班级名称",
      "min-width": "145",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "teacherName",
      label: "老师姓名",
      "min-width": "100",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "classType",
      label: "班级类型",
      "min-width": "90",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "campusName",
      label: "校区名称",
      "min-width": "100",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "course",
      label: "科目",
      "min-width": "100",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "period",
      label: "上课时段",
      "min-width": "120",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "hour",
      label: "课时(小时)",
      width: "100",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      label: "课时合计",
      width: "95",
      align: "center"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString($options.preparedDesenRows[scope.row._primaryStart].primaryTotalHour), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "课程通知",
      width: "95",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_checkbox, {
        modelValue: scope.row.courseNotified,
        "onUpdate:modelValue": $event => scope.row.courseNotified = $event,
        onChange: checked => $options.saveDesenCheck(scope.row, 'courseNotified', checked)
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "课消",
      width: "85",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_checkbox, {
        modelValue: scope.row.courseCleared,
        "onUpdate:modelValue": $event => scope.row.courseCleared = $event,
        onChange: checked => $options.saveDesenCheck(scope.row, 'courseCleared', checked)
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data", "style", "row-key", "span-method", "onScroll", "onCellMouseEnter", "onCellMouseLeave"]), _cache, 23), $data.desenTooltipVisible ? (_openBlock(), _createBlock(_component_el_tooltip, {
    key: 0,
    visible: true,
    "virtual-triggering": "",
    "virtual-ref": $data.desenTooltipTarget,
    content: $data.desenTooltipText,
    enterable: false,
    placement: "top",
    "popper-class": "desen-cell-overflow-tooltip"
  }, null, 8, ["virtual-ref", "content"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, "共 " + _toDisplayString($options.preparedDesenRows.length) + " 行复选框", 1), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("span", null, "一对一：" + _toDisplayString($options.desenHoursByClassType.oneToOne) + "小时", 1), _createElementVNode("span", null, "班课：" + _toDisplayString($options.desenHoursByClassType.group) + "小时", 1), $options.desenHoursByClassType.hasOther ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("span", null, "其他班级类型：" + _toDisplayString($options.desenHoursByClassType.other) + "小时", 1), _createVNode(_component_el_tooltip, {
    placement: "top",
    "popper-class": "desen-other-type-tooltip",
    disabled: $data.displayedStatisticsType !== 'student' || $data.statisticsBusy
  }, {
    content: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.desenHoursByClassType.otherDetails, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item.type
      }, _toDisplayString(item.type) + "：" + _toDisplayString(item.hour) + "小时 ", 1);
    }), 128))]),
    default: _withCtx(() => [_cache[38] || (_cache[38] = _createElementVNode("button", {
      type: "button",
      class: "desen-other-type-help",
      "aria-label": "查看其他班级类型课时明细"
    }, "?", -1))]),
    _: 1,
    __: [38]
  }, 8, ["disabled"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_46, "共" + _toDisplayString($options.desenTotalHour) + "小时", 1)])])], 12, _hoisted_40)) : _createCommentVNode("", true), $data.showStatisticsType == 'student' && $data.institution != '得森' ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_cache[39] || (_cache[39] = _createStaticVNode("<div style=\"height:78px;width:1514px;display:flex;align-items:center;font-size:20px;font-weight:bold;border-top:1px solid #d5d8e1;border-bottom:1px solid #d5d8e1;padding:0px 0 0 0px;\" data-v-f7bf24f2><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>学生姓名</div><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>班级</div><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>班级类型</div><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>校区名称</div><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>科目</div><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>课时(小时)</div><div style=\"flex:1;text-align:center;\" data-v-f7bf24f2>课时合计</div></div>", 1)), _createElementVNode("div", _hoisted_48, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.studentClassCourseHour, (item, studentId) => {
    return _openBlock(), _createElementBlock("div", {
      key: studentId,
      style: {
        "width": "1514px",
        "display": "flex"
      }
    }, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, _toDisplayString($data.studentNames[studentId]), 1)]), _createElementVNode("div", _hoisted_51, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.studentClassCourseHour[studentId], (item2, classId) => {
      return _openBlock(), _createElementBlock("div", {
        key: classId,
        style: {
          "flex": "5",
          "display": "flex"
        }
      }, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, _toDisplayString($data.classNames[classId]), 1), _createElementVNode("div", _hoisted_54, _toDisplayString($data.classType[classId]), 1), _createElementVNode("div", _hoisted_55, _toDisplayString($data.campusNames[$data.classCampusId[classId]]), 1)]), _createElementVNode("div", _hoisted_56, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.studentClassCourseHour[studentId][classId], (item3, course) => {
        return _openBlock(), _createElementBlock("div", {
          key: course,
          style: {
            "height": "78px",
            "flex": "2",
            "display": "flex",
            "align-items": "center",
            "font-size": "20px",
            "border-bottom": "1px solid #d5d8e1",
            "padding": "0px 0 0 0px"
          }
        }, [_createElementVNode("div", _hoisted_57, _toDisplayString(item3.course), 1), _createElementVNode("div", _hoisted_58, _toDisplayString(item3.hour), 1)]);
      }), 128))])]);
    }), 128))]), _createElementVNode("div", _hoisted_59, _toDisplayString($data.studentHours[studentId]), 1)]);
  }), 128))]), _createElementVNode("div", _hoisted_60, " 共" + _toDisplayString(parseFloat($data.totalHour.toFixed(2))) + "小时 ", 1), _cache[40] || (_cache[40] = _createElementVNode("div", {
    style: {
      "height": "100%",
      "width": "100%",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "background": "white"
    }
  }, null, -1))])) : _createCommentVNode("", true)]);
}